import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError, concatMap, finalize } from 'rxjs/operators';
import { v4 } from 'uuid';

import { ShouldIgnoreLoader } from '../../typings/property-force-api';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);
  private ngZone = inject(NgZone);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const ignoreLoader = request.context.get(ShouldIgnoreLoader);
    if (ignoreLoader) {
      return next.handle(request);
    } else {
      const id = v4();
      this.loadingService.setLoading(id, true);
      return next.handle(request).pipe(
        concatMap((event) => {
          if (event instanceof HttpResponse) {
            this.ngZone.run(() => {
              this.loadingService.setLoading(id, false);
            });
          }
          return of(event);
        }),
        catchError((error) => {
          this.ngZone.run(() => {
            this.loadingService.setLoading(id, false);
          });
          return throwError(() => error);
        }),
        finalize(() => {
          this.ngZone.run(() => {
            this.loadingService.setLoading(id, false);
          });
        })
      );
    }
  }
}
